module.exports = __webpack_public_path__ + "img/service_mornitoring.0ac2766d.png";